import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/settings/report/")({
  beforeLoad: () => {
    throw redirect({
      to: "/settings/report/daily",
    })
  },
})
